"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsRequestContext = exports.getRequestContextFromPageProps = exports.REQUEST_CONTEXT_PAGE_PROP = void 0;
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const getRequestContextWeb_1 = __importDefault(require("./getRequestContextWeb"));
exports.REQUEST_CONTEXT_PAGE_PROP = '_rct';
const requestContextPropGetter = (0, libs_next_utils_1.createPagePropGetter)(exports.REQUEST_CONTEXT_PAGE_PROP);
function getRequestContextFromPageProps(pageProps) {
    return requestContextPropGetter(pageProps);
}
exports.getRequestContextFromPageProps = getRequestContextFromPageProps;
function usePagePropsRequestContext(pageProps) {
    return (getRequestContextFromPageProps(pageProps) ||
        (0, getRequestContextWeb_1.default)());
}
exports.usePagePropsRequestContext = usePagePropsRequestContext;
//# sourceMappingURL=RequestContext.utils.js.map